import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

import { breakpoint, themeColor, themeSpace } from '../theme'

const FilterStripContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  background: ${themeColor('primary')};
  padding: ${themeSpace(3)};
  border-radius: 4px;
  width: 100%;

  ${breakpoint.tablet(css`
    flex-direction: row;
  `)}
`

const Title = styled.div`
  white-space: nowrap;
  font-weight: bold;
  ${breakpoint.tablet(css`
    align-self: center;
  `)}
`

export interface FilterStripProps {
  title?: string
}

export const FilterStrip: FunctionComponent<FilterStripProps> = ({ title, children }) => {
  return (
    <FilterStripContainer>
      <Title>{title}</Title>
      {children}
    </FilterStripContainer>
  )
}
